import OLFormatGeoJSON from 'ol/format/GeoJSON'
import OLFormatWKT from 'ol/format/WKT'

export default function (wkt) {
  const features = new OLFormatWKT().readFeatures(wkt)
  const geoJSONString = new OLFormatGeoJSON().writeFeatures(features)
  return JSON.parse(geoJSONString)
}
